<template>
    <b-modal id="file-manager-rename-item-modal" size="sm">

        <template #modal-header>
            <h4 class="modal-title">{{ t.__('Zmień nazwę') }}</h4>
            <button type="button" class="close" @click="close()"><span aria-hidden="true">&times;</span></button>
        </template>

        <template #default>
            <div class="form-group">
                <label>{{ t.__('Obecna nazwa') }}</label>
                <p class="form-control-static">{{ getItemName(currentFile) }}</p>
            </div>
            <div class="form-group fg-line">
                <label>{{ t.__('Nowa nazwa') }}</label>
                <input ref="newItemName"
                       v-model="newItemName"
                       type="text"
                       class="form-control"
                       @keyup.enter="renameItem()">
            </div>
            <file-manager-errors :errors="errors"/>
        </template>

        <template #modal-footer>
            <button class="btn btn-light"
                    type="button"
                    @click="close()">
                {{ t.__('Anuluj') }}
            </button>
            <button class="btn btn-primary"
                    type="button"
                    @click="renameItem()">
                <template v-if="loading">{{ t.__('Zmieniam nazwę...') }}</template>
                <template v-if="!loading">{{ t.__('Zmień nazwę') }}</template>
            </button>
        </template>

    </b-modal>
</template>

<script>

    import axios from "axios";
    import fileManagerMixin from "../file-manager-mixin";
    import FileManagerErrors from "./FileManagerErrors";

    export default {
        components: {
            'file-manager-errors': FileManagerErrors,
        },

        mixins: [fileManagerMixin],

        props: {
            currentPath: {
                default: '',
                type: String
            },
            currentFile: {
                default: function () {
                    return {};
                },
                type: [Object, Boolean]
            },
            show: {
                default: false,
                type: Boolean
            }
        },

        data() {
            return {
                errors: [],
                loading: false,
                newItemName: null,
                size: 'modal-sm'
            };
        },

        mounted() {
            document.addEventListener('keydown', (e) => {
                if (this.show && e.keyCode === 13) {
                    this.renameItem();
                }
            });
        },

        methods: {
            close() {
                this.errors = [];
                this.newItemName = null;
                this.loading = false;
                this.$bvModal.hide('file-manager-rename-item-modal');
            },

            renameItem() {
                if (!this.newItemName) {
                    this.errors = [t.__('Proszę wpisać nazwę')];
                } else {
                    this.loading = true;
                    const data = {
                        'path': this.currentPath,
                        'current_name': this.getItemName(this.currentFile),
                        'new_name': this.newItemName
                    };

                    axios.post('/file-manager/rename', data).then(
                        (response) => {
                            this.$emit('reload-folder');
                            this.fileManagerNotify(response.data.success, 'success');
                            this.close();
                        }).catch((error) => {
                        this.errors = (error.response.data.message) ? (Array.isArray(error.response.data.message) ? error.response.data.message : [error.response.data.message] ) : [error.response.statusText];
                        this.loading = false;
                    });
                }
            }
        }

    };
</script>
